import  { useState, useRef, useEffect, useCallback } from "react";
import "./RangeSlider.css"; // استایل جدا
import BasicInput from "../edittext/basicInput/basicInput";

const PriceRange = ({ setMaxPrice, setMinPrice }) => {
  const MIN = 0;
  const MAX = 100000;
  const STEP = 100;

  const [minVal, setMinVal] = useState(MIN);
  const [maxVal, setMaxVal] = useState(MAX);

  const range = useRef(null);

  // --- helpers
  const getRaw = (eOrVal) =>
    eOrVal && typeof eOrVal === "object" && "target" in eOrVal
      ? eOrVal.target.value
      : eOrVal;

  const toNum = (x) => {
    const n = Number(x);
    return Number.isFinite(n) ? n : 0;
  };

  const clampMin = (v) =>
    Math.min(Math.max(v, MIN), Math.max(maxVal - STEP, MIN));
  const clampMax = (v) =>
    Math.max(Math.min(v, MAX), Math.min(minVal + STEP, MAX));

  // --- inputs (BasicInput)
  const handleMinInput = useCallback(
    (eOrVal) => {
      const v = toNum(getRaw(eOrVal));
      setMinVal(clampMin(v));
    },
    [maxVal]
  );

  const handleMaxInput = useCallback(
    (eOrVal) => {
      const v = toNum(getRaw(eOrVal));
      setMaxVal(clampMax(v));
    },
    [minVal]
  );

  const handleMinBlur = () => setMinVal((v) => Math.round(v / STEP) * STEP);
  const handleMaxBlur = () => setMaxVal((v) => Math.round(v / STEP) * STEP);

  // --- sliders
  const handleMinSlider = (e) => setMinVal(clampMin(toNum(e.target.value)));
  const handleMaxSlider = (e) => setMaxVal(clampMax(toNum(e.target.value)));

  // --- paint selected range
  useEffect(() => {
    if (!range.current) return;
    const p1 = ((minVal - MIN) / (MAX - MIN)) * 100;
    const p2 = ((maxVal - MIN) / (MAX - MIN)) * 100;
    range.current.style.left = `${p1}%`;
    range.current.style.width = `${p2 - p1}%`;
    // console.log("max", maxVal);
    setMaxPrice(maxVal);
    setMinPrice(minVal);
  }, [minVal, maxVal]);

  return (
    <div className="price-range-box">
      <div className="slider-container">
        <input
          type="range"
          min={MIN}
          max={MAX}
          step={STEP}
          value={minVal}
          onChange={handleMinSlider}
          className="thumb thumb--left"
        />
        <input
          type="range"
          min={MIN}
          max={MAX}
          step={STEP}
          value={maxVal}
          onChange={handleMaxSlider}
          className="thumb thumb--right"
        />
        <div className="slider">
          <div className="slider__track" />
          <div ref={range} className="slider__range" />
        </div>
      </div>

      <div className="row align-items-center gap-2 mt-3">
        <BasicInput
          type="number"
          bgcolor="white"
          step={STEP}
          inputMode="numeric"
          text="Min Price"
          textAlign="right"
          value={minVal}
          onChange={handleMinInput} // ← حالا هم با event هم با value کار می‌کنه
          onBlur={handleMinBlur}
        />
        <BasicInput
          type="number"
          step={STEP}
          bgcolor="white"
          inputMode="numeric"
          text="Max Price"
          textAlign="right"
          value={maxVal}
          onChange={handleMaxInput} // ← همین‌طور این
          onBlur={handleMaxBlur}
        />
      </div>
    </div>
  );
};

export default PriceRange;
